import { RedeemChallengeAction } from './redeem-challenge';

export const success: RedeemChallengeAction = async () => {
	return;
};


export const challengeMocks = {
	success: success
};
